/**
 * Import classes
 */
import SelectColor from '../../modules/format/selectColor';
import RequiredValidation from '../../modules/validation/requiredValidation';
import DisabledHandler from '../../modules/validation/disabledHandler';
import DomainSuggest from '../../modules/email/domainSuggest';

/**
 * Make instances
 */
const selectColor = new SelectColor();
const required = new RequiredValidation();
const disabledHandler = new DisabledHandler();
const domainSuggest = new DomainSuggest();

/**
 * Execute functions
 */
// セレクトの文字色
selectColor.onChange();
selectColor.onLoad();
// 必須項目バリデーション
required.validate();
// submitボタンクリッカブル操作
disabledHandler.validate();
// emailドメイン自動補完
domainSuggest.enableSuggestion();
